import React, { useContext, useState } from "react";
import "./styles";
import { Link, useLocation } from "react-router-dom";
import { EmpresaContext } from "../../contexts/Empresa/EmpresaContext";
import { AssinaturaContext } from "../../contexts/Assinatura/AssinaturaContext";
import { useEffect } from "react";
import FotoUsuario from "../../components/Uteis/FotoUsuario";
import { ScrollDirectionContext } from "../../contexts/ScrollDirection/ScrollDirectionContext";
import { ViewMenuLateral } from "./styles";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { ReactComponent as LogoSVG } from "../../assets/newImages/menuLateral/Logo.svg";
import { ReactComponent as IconeMeuPainelSVG } from "../../assets/newImages/menuLateral/painel.svg";
import { ReactComponent as IconeCompartilharSVG } from "../../assets/newImages/menuLateral/share.svg";
import { ReactComponent as IconeMetricasSVG } from "../../assets/newImages/menuLateral/dash.svg";
import { ReactComponent as IconeConfiguracoesSVG } from "../../assets/newImages/menuLateral/config.svg";
import { ReactComponent as IconePerfilSVG } from "../../assets/newImages/menuLateral/user.svg";
import { ReactComponent as IconeAssinaturaSVG } from "../../assets/images/icons/money.svg";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { PERMISSOES } from "../../services/Consts";

const MenuLateral: React.FC = (props) => {
  const { theme } = useTheme();
  const { permissoesUsuario, customizadas } = useContext(AuthContext);
  // Métricas não tem permissão grossa; customizado só vê com 160/161, não-customizado vê como hoje.
  const podeVerMetricas =
    !customizadas ||
    permissoesUsuario?.includes(PERMISSOES.METRICAS_GERAL) ||
    permissoesUsuario?.includes(PERMISSOES.METRICAS_MINHAS);
  const [menuAtivo, setMenuAtivo] = useState("meuPainel");
  const [submenuPerfilAberto, setSubmenuPerfilAberto] = useState(false);
  const { empresa, setEmpresa } = useContext(EmpresaContext);
  const { fluxoNovo } = useContext(AssinaturaContext);

  const scrollDir = useContext(ScrollDirectionContext).direction;
  const location = useLocation();

  // "Minha conta": cada item gateado por sua permissão; o menu abre se houver qualquer um.
  const podeVerUsuarios = permissoesUsuario?.includes(PERMISSOES.USUARIOS_GERENTE);
  const podeVerConfiguracoes = permissoesUsuario?.includes(PERMISSOES.CONFIGURACOES);
  // Assinatura não tem id legado: vê quem tem 180 OU é Gerente não-customizado (tem 7, sem pílula 150-153).
  const temPilulaUsuarios = [
    PERMISSOES.USUARIOS_CRIAR,
    PERMISSOES.USUARIOS_EDITAR_GERAL,
    PERMISSOES.USUARIOS_EDITAR_MEU,
    PERMISSOES.USUARIOS_EXCLUIR,
  ].some((id) => permissoesUsuario?.includes(id));
  const podeVerAssinatura =
    permissoesUsuario?.includes(PERMISSOES.ASSINATURAS_VER) ||
    (podeVerUsuarios && !temPilulaUsuarios);
  // Assinatura só é item de menu no fluxo novo (no antigo vive no Perfil); senão abriria menu vazio.
  const podeAbrirMinhaConta =
    podeVerUsuarios ||
    podeVerConfiguracoes ||
    (fluxoNovo === true && podeVerAssinatura);

  const isIos = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };

  let ios = isIos();

  useEffect(() => {
    setMenuAtivo(
      location.pathname.includes("configuracoes")
        ? "configuracao"
        : location.pathname.includes("compartilhar")
        ? "compartilhar"
        : location.pathname.includes("metricas")
        ? "metricas"
        : location.pathname.includes("assinatura")
        ? "assinatura"
        : location.pathname.includes("perfil")
        ? "perfil"
        : "meuPainel"
    );
  }, [location.pathname]);

  return (
    <>
      <ViewMenuLateral theme={theme}>
        <div
          className={`view-menu-lateral ${
            scrollDir === "up" && "bottomAtivo"
          } ${ios && "ios"}`}
        >
          <div className="fixedContainer">
            <Link
              className="hideMobile"
              to={"/"}
              style={{ textDecoration: "none" }}
            >
              <div className="logoConecta">
                <LogoSVG />
              </div>
            </Link>
            <div className="menus">
              <Link
                to={"/empresa-catalogos"}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={`menuContainer ${
                    menuAtivo == "meuPainel" ? "ativo" : ""
                  }`}
                >
                  <div className="menu tamanhoIcone">
                    <IconeMeuPainelSVG className="icone-svg" />
                  </div>
                  <div className="nomeMenu fonteTexto">Meu painel</div>
                </div>
              </Link>
              {podeVerMetricas ? (
                <Link to={"/metricas"} style={{ textDecoration: "none" }}>
                  <div
                    className={`menuContainer ${
                      menuAtivo == "metricas" ? "ativo" : ""
                    }`}
                  >
                    <div className="menu tamanhoIcone">
                      <IconeMetricasSVG className="icone-svg" />
                    </div>
                    <div className="nomeMenu fonteTexto">Métricas</div>
                  </div>
                </Link>
              ) : (
                <div
                  className="menuContainer menu--disabled"
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                  title="Você não tem permissão para acessar"
                >
                  <div className="menu tamanhoIcone">
                    <IconeMetricasSVG className="icone-svg" />
                  </div>
                  <div className="nomeMenu fonteTexto">Métricas</div>
                </div>
              )}
              <Link to={"/compartilhar"} style={{ textDecoration: "none" }}>
                <div
                  className={`menuContainer ${
                    menuAtivo == "compartilhar" ? "ativo" : ""
                  }`}
                >
                  <div className="menu tamanhoIcone">
                    <IconeCompartilharSVG className="icone-svg" />
                  </div>
                  <div className="nomeMenu fonteTexto">Compartilhar</div>
                </div>
              </Link>
              {/* Configurações - sempre mostra, mas só clicável se tiver permissão */}
              {/* {permissoesUsuario?.includes(PERMISSOES.CONFIGURACOES) ? (
                <Link
                  to={"/painel/configuracoes"}
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className={`menuContainer ${
                      menuAtivo == "configuracao" ? "ativo" : ""
                    }`}
                  >
                    <div className="menu tamanhoIcone">
                      <IconeConfiguracoesSVG className="icone-svg" />
                    </div>
                    <div className="nomeMenu fonteTexto">Configuração</div>
                  </div>
                </Link>
              ) : (
                <div
                  className="menuContainer menu--disabled"
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                  title="Você não tem permissão para acessar"
                >
                  <div className="menu tamanhoIcone">
                    <IconeConfiguracoesSVG className="icone-svg" />
                  </div>
                  <div className="nomeMenu fonteTexto">Configuração</div>
                </div>
              )} */}
            </div>
            <div className="logoPerfil hideMobile">
              {/* Perfil - sempre mostra, mas só clicável se tiver permissão */}
              {podeAbrirMinhaConta ? (
                <div className="perfil-wrapper">
                  <div
                    className={`menuContainer ${menuAtivo == "perfil" || menuAtivo == "configuracao" || menuAtivo == "assinatura" ? "ativo" : ""}`}
                    onClick={() => setSubmenuPerfilAberto(!submenuPerfilAberto)}
                  >
                    <FotoUsuario
                      size={5}
                      ativo={menuAtivo == "perfil" || menuAtivo == "configuracao" || menuAtivo == "assinatura"}
                    ></FotoUsuario>
                    <div className="nomeMenu fonteTexto">Minha conta</div>
                  </div>
                  {submenuPerfilAberto && (
                    <div className="submenu-perfil">
                      {podeVerUsuarios ? (
                        <Link
                          to={"/perfil/usuarios"}
                          style={{ textDecoration: "none" }}
                          onClick={() => setSubmenuPerfilAberto(false)}
                        >
                          <div className="submenu-item fonteTexto">
                            <IconePerfilSVG className="icone-svg" />
                            Usuários
                          </div>
                        </Link>
                      ) : (
                        <div
                          className="submenu-item fonteTexto"
                          style={{ opacity: 0.5, cursor: "not-allowed" }}
                          title="Você não tem permissão para acessar"
                        >
                          <IconePerfilSVG className="icone-svg" />
                          Usuários
                        </div>
                      )}
                      {fluxoNovo === true &&
                        (podeVerAssinatura ? (
                          <Link
                            to={"/assinatura"}
                            style={{ textDecoration: "none" }}
                            onClick={() => setSubmenuPerfilAberto(false)}
                          >
                            <div className="submenu-item fonteTexto">
                              <IconeAssinaturaSVG className="icone-svg" />
                              Assinatura
                            </div>
                          </Link>
                        ) : (
                          <div
                            className="submenu-item fonteTexto"
                            style={{ opacity: 0.5, cursor: "not-allowed" }}
                            title="Você não tem permissão para acessar"
                          >
                            <IconeAssinaturaSVG className="icone-svg" />
                            Assinatura
                          </div>
                        ))}
                      {podeVerConfiguracoes ? (
                        <Link
                          to={"/painel/configuracoes"}
                          style={{ textDecoration: "none" }}
                          onClick={() => setSubmenuPerfilAberto(false)}
                        >
                          <div className="submenu-item fonteTexto">
                            <IconeConfiguracoesSVG className="icone-svg" />
                            Configurações
                          </div>
                        </Link>
                      ) : (
                        <div
                          className="submenu-item fonteTexto"
                          style={{ opacity: 0.5, cursor: "not-allowed" }}
                          title="Você não tem permissão para acessar"
                        >
                          <IconeConfiguracoesSVG className="icone-svg" />
                          Configurações
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="menuContainer menu--disabled"
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                  title="Você não tem permissão para acessar"
                >
                  <FotoUsuario
                    size={5}
                    ativo={false}
                  ></FotoUsuario>
                  <div className="nomeMenu fonteTexto">Minha conta</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </ViewMenuLateral>
    </>
  );
};

export default MenuLateral;
